import * as constants from './constants';

const initialState = {
  statusOptions: [],
  allTenants: [],
  currentTenantObj: {},
  utilsData: {},
  updateNotLoading: false,
  departmentsList: [],
  createTenantLoading: false,
  tenantDetailsIsEdit: false,
  fetchTenantsLoading: false,
  deleteTenantLoading: false,
  fetchTenantDetailLoading: false,
  totalRecords: 0,
  deleteAttachLoading: false,
  tenantNotificationIsEdit: false,
  search: {},
};

const tenantsReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.FETCH_TENANTS_UTIL_DATA_SUCCESS:
      // const { sales_reps } = action.data;
      return {
        ...state,
        utilsData: {
          ...action.data,
        },
      };
    case constants.TENANT_DETAILS_IS_EDIT:
      return {
        ...state,
        tenantDetailsIsEdit: action.data,
      };

    case constants.CREATE_TENANT:
      return {
        ...state,
        createTenantLoading: true,
      };
    case constants.CREATE_TENANT_SUCCESS:
      return {
        ...state,
        createTenantLoading: false,
        currentTenantObj: action.data,
        tenantDetailsIsEdit: false,
      };
    case constants.CREATE_TENANT_ERROR:
      return {
        ...state,
        createTenantLoading: false,
      };
    case constants.UPDATE_TENANT:
      return {
        ...state,
        createTenantLoading: true,
      };
    case constants.UPDATE_TENANT_SUCCESS:
      return {
        ...state,
        createTenantLoading: false,
        currentTenantObj: action.data,
        tenantDetailsIsEdit: false,
      };
    case constants.UPDATE_TENANT_ERROR:
      return {
        ...state,
        createTenantLoading: false,
      };

    case constants.UPDATE_TENANT_NOTIFICATION:
      return {
        ...state,
        updateNotLoading: true,
      };
    case constants.UPDATE_TENANT_NOTIFICATION_SUCCESS:
      return {
        ...state,
        updateNotLoading: false,
        tenantNotificationIsEdit: false,
      };
    case constants.UPDATE_TENANT_NOTIFICATION_ERROR:
      return {
        ...state,
        updateNotLoading: false,
      };

    case constants.FETCH_ALL_TENANTS:
      return {
        ...state,
        fetchTenantsLoading: true,
      };
    case constants.FETCH_ALL_TENANTS_SUCCESS:
      const { tenants, total } = action.data;

      return {
        ...state,
        allTenants: tenants,
        fetchTenantsLoading: false,
        totalRecords: total,
      };
    case constants.FETCH_ALL_TENANTS_ERROR:
      return {
        ...state,
        fetchTenantsLoading: false,
      };
    case constants.DELETE_TENANT:
      return {
        ...state,
        deleteTenantLoading: true,
      };
    case constants.DELETE_TENANT_SUCCESS:
      let updatedTenants = state.allTenants.filter(
        (el) => el._id !== action.data._id
      );

      let totalRecords = state.totalRecords - 1;

      return {
        ...state,
        totalRecords: totalRecords,
        deleteTenantLoading: false,
        allTenants: updatedTenants,
      };
    case constants.DELETE_TENANT_ERROR:
      return {
        ...state,
        deleteTenantLoading: false,
      };

    case constants.DELETE_TENANT_ATTACH:
      return {
        ...state,
        deleteAttachLoading: true,
      };
    case constants.DELETE_TENANT_ATTACH_SUCCESS:
      const { id } = action.data;

      let updatedDocs = state.currentTenantObj.document_urls.filter(
        (el) => el.id != id
      );

      return {
        ...state,
        deleteAttachLoading: false,
        currentTenantObj: {
          ...state.currentTenantObj,
          document_urls: updatedDocs,
        },
      };
    case constants.DELETE_TENANT_ATTACH_ERROR:
      return {
        ...state,
        deleteAttachLoading: false,
      };

    case constants.FETCH_TENANT:
      return {
        ...state,
        // departmentLoading: true,
        fetchTenantDetailLoading: true,
      };
    case constants.FETCH_TENANT_SUCCESS:
      const { tenant } = action.data;
      return {
        ...state,
        currentTenantObj: { ...tenant },
        fetchTenantDetailLoading: false,
      };
    case constants.FETCH_TENANT_ERROR:
      return {
        ...state,
        fetchTenantDetailLoading: false,
      };

    case constants.TENANT_NOTIF_IS_EDIT:
      return {
        ...state,
        tenantNotificationIsEdit: action.data,
      };

    case constants.SET_TENANTS_MANAGER_STATE:
      const { search } = state;

      localStorage.setItem(
        'tenantsManagerState',
        JSON.stringify({ search, ...action.data })
      );
      return {
        ...state,
        ...action.data,
      };

    case constants.TENANT_DETAIL_CLEANUP_FUNC:
      return {
        ...state,
        allTenants: [],
        createTenantLoading: false,
        currentTenantObj: {},
        tenantDetailsIsEdit: false,
        fetchTenantsLoading: false,
        deleteTenantLoading: false,
        tenantNotificationIsEdit: false,
      };
    default:
      return state;
  }
};

export default tenantsReducer;
